import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { SalesService } from "../../services/sales/sales.service";
import { AuthenticationService } from '../../services/auth/authentication.service';
import { Subscription, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ClientDepartments } from '../../services/auth/auth.models';
import * as XLSX from 'xlsx';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageModel } from '../sales.models';


@Component({
  selector: 'app-quotations',
  templateUrl: './quotations.component.html',
  styleUrls: ['./quotations.component.scss']
})
export class QuotationsComponent implements OnInit, OnDestroy {
  public quotations = [];
  public temp = [];
  fileName= 'Cotizaciones.xlsx';

  private subs: Array<Subscription> = [];
  private modalContent: any;
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();

  public submitted = false;
  public isLoading = false;
  public messageIsSuccess = false;
  public quotationId: number;
  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private salesService: SalesService,
    private authService: AuthenticationService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
        emptyTable: '',
        zeroRecords: 'No hay coincidencias',
        lengthMenu: 'Mostrar _MENU_ elementos',
        search: 'Buscar:',
        info: 'De _START_ a _END_ de _TOTAL_ elementos',
        infoEmpty: 'De 0 a 0 de 0 elementos',
        infoFiltered: '(filtrados de _MAX_ elementos totales)',
        paginate: {
          first: 'Prim.',
          last: 'Últ.',
          next: 'Sig.',
          previous: 'Ant.'
        },
      },
      order:[[0, 'desc']]
    };

    this.subs.push(
      this.salesService
        .getQuotations()
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          this.quotations = data;
          this.dtTrigger.next();
        })
    );

    this.form = this.fb.group({
      MessageResponse: ['', Validators.required],
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.subs.forEach(sub => sub.unsubscribe());
  }

  public setModalContent(content: any, quotationId: number): void {
    this.quotationId = quotationId;
    this.modalContent = content;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  public get formState() {
    return this.form.controls
  }

  private buildMessage(): MessageModel {
    return {
      MessageResponse: this.form.controls['MessageResponse'].value,
      RequestStatus: 'Atendida'
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    const message: MessageModel = this.buildMessage();
    this.isLoading = true;
    this.subs.push(
      this.salesService.addMessage(message, this.quotationId)
        .subscribe(resolve => {
          if (resolve.message == 'Cotización actualizada correctamente') {
            this.messageIsSuccess = true;
            setTimeout(() => {
              this.modalService.dismissAll();
              window.location.reload();
            }, 1500);
          }
        })
    );
  }

  exportExcel(): void
  {
    let element = document.getElementById('excel-quotations');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cotizaciones');
  
    XLSX.writeFile(wb, this.fileName);
 
  }

}
